
export const helperFunctions = {
	adminType,
	getPermissionCompany,
	returnLabelWithValue,
	returnValueOfLocalStorageUser,
	openModal,
	closeModal,
	closeModalAfterApi,
	toggleModal,
	returnExtFromImage,
	removeDuplicateImage,
	returnTimeStamp
};

function adminType() {
	var userAdmin = JSON.parse(localStorage.getItem('admin-user'));
	if (userAdmin){
		return userAdmin.type;
	}
}

function getPermissionCompany() {
	var userAdmin = JSON.parse(localStorage.getItem('admin-user'));
	if (userAdmin){
		return userAdmin.user.permission ? true :false;
	}
}

function returnValueOfLocalStorageUser(name, column) {
	var storage = JSON.parse(localStorage.getItem(name));
	if (storage){
		return storage.user[column];
	}
}
function returnLabelWithValue(value, ObjectArray, defaultLabel = null ) {
	if (value) {
		for (var key in ObjectArray) {
			if (ObjectArray[key]['value'] === value) {
				return {
					value: ObjectArray[key]['value'], label: ObjectArray[key]['label']
				};
			}
		}
	} 
	else if (defaultLabel) {
		for (var keyN in ObjectArray) {
			if (ObjectArray[keyN]['label'] === defaultLabel) {
				return {
					value: ObjectArray[keyN]['value'], label: ObjectArray[keyN]['label']
				};
			}
		}
	}
	return null;
}

function openModal(name) {
	
	this.setState({
		[name]: true
	});
}
function closeModal(modalName) {
	console.log('close modal call 789');
	this.setState({
		[modalName]: false
	})
}

function closeModalAfterApi(modalName, afterApi) {
	this.setState({
		[modalName]: false,
		[afterApi]:true
	})
}

function toggleModal(name) {
	this.setState({
		[name]: !this.state[name]
	});
}
function returnExtFromImage(imageName) {
	var ext = imageName.substr(imageName.lastIndexOf('.') + 1);
	return ext;
}

function removeDuplicateImage(val, AllImgs) {
	for (var i in AllImgs) {
		if ((AllImgs[i].name === val.name)) {
			if ((AllImgs[i].file === val.file))
				return { val: val, duplicate: true, name: val.name, index: i, message: val.name + ' Image name and file is same' }
			else
				return { val: val, duplicate: true, name: val.name, index: i, message: val.name + ' Image file name is same' }
		}
	}
	return { duplicate: false, val: val, name: val.name };
}

function returnTimeStamp(dataString) {
	const dateTime = new Date(dataString).getTime();
	const timestamp = Math.floor(dateTime / 1000);
	return timestamp;
}


// WEBPACK FOOTER //
// ./src/helper/helperFunctions.js